import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { FilterProjectDto } from 'src/app/web/interfaces/project/list/filterProjectDto';
import { FilterProjectInfoDto } from 'src/app/web/interfaces/project/list/filterProjectInfoDto';
import { FilterProjectInfoFrenteDto } from 'src/app/web/interfaces/project/list/filterProjectInfoFrenteDto';
import { FilterProjectInfoItemDto } from 'src/app/web/interfaces/project/list/filterProjectInfoItemDto';
import { FilterProjectStadoDto } from 'src/app/web/interfaces/project/list/filterProjectStadoDto';
import { ViewProject } from 'src/app/web/interfaces/project/list/viewProjectDto';
import { DropdownSettingsStado, FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { Router } from '@angular/router';
import { creatingprojectlistDto } from 'src/app/web/interfaces/project/list/creatingprojectlistDto';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';



@Component({
  selector: 'app-creating-project',
  templateUrl: './creating-project.component.html',
  styleUrls: ['./creating-project.component.scss']
})
export class CreatingProjectComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};

  private apiService: ApiServiceProject;
  creatingList:creatingprojectlistDto[] = []
  searchForm: FormGroup;
  listViewProjectDto: ViewProject[] = []
  listViewProjectDtoBack: ViewProject[] = []
  filterProjectInfoDto: FilterProjectInfoDto = {} as FilterProjectInfoDto
  filterProjectInfoFrenteDto: FilterProjectInfoFrenteDto[] = []
  filterProjectDto: FilterProjectDto = {} as FilterProjectDto;

  selectedItems = [];
  dropdownSettings = {};
  opcionClient = 0
  opcionFrete = 0
  opcionSeleccionado = "todo"

  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    config: NgbDropdownConfig,
    private fb: FormBuilder,
    private router: Router,
    private errorService:ErrorService
  ) 
    {
      config.placement = 'bottom';
    }

  ngOnInit(): void {
    this.spinner.show()
    this.dtOptions = FormatDataTableGlobal();
    this.apiService = new ApiServiceProject(this.http);


    //this.spinner.show();

    this.apiService.getService("list-init-project-info").subscribe({
      next: (rs:any) => {
        if(rs){
          this.creatingList = rs.listInfo
          this.spinner.hide()
          this.rerender();
        }
        
      },
      error: (error) => {
        this.errorService.error(error);
      }
    });

  }
 stageDelete(id:any){
      Swal.fire({
                title: 'Eliminar',
                text: '¿Desea eliminar registro?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Aceptar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                  this.apiService.deleteService('delete-init-project-info?id=' + id).subscribe({
                    next: (rs: any) => {
                      if (rs) {
                        this.spinner.hide();
                        Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                        
                      } else {
                          this.spinner.hide();
                          Swal.fire({
                          title:  rs.error,
                          text: '',
                          icon: 'error',
                          heightAuto: false
                          }); } },
                    error: (error) => {
                      this.errorService.error(error);
                    },});
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({
                    title: 'Cancelado',
                    text: 'Operación cancelada.',
                    icon: 'error',
                    heightAuto: false
                    })

                }
              });
    
    
  }

  onItemSelect(item: any) {

  }



  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }



}
